import React, { useEffect, useState } from 'react';
import { Box, TextField, withStyles } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { filters } from './styles';
import { useReportFilterItems } from '../../../hooks/reportFilterItems';

function CoursesFilter({ classes, label, handleFilterChange, filters }) {
    const { courseList } = useReportFilterItems();
    const [selectedItems, setSelectedItems] = useState([]);

    useEffect(() => {
        if (courseList.length > 0) {
            const value = filters['courses'];
            if (value) {
                setSelectedItems(value.map(sv => courseList.find(s => s.value === sv.value)));
            }
        }
    }, [filters, courseList]);

    const handleChange = (_, items) => {
        handleFilterChange({
            courses: items
        });
        setSelectedItems(items);
    };

    return (
        <Box marginTop={4}>
            <Autocomplete
                multiple
                className={classes.autocomplete}
                options={courseList}
                value={selectedItems}
                onChange={handleChange}
                label={label}
                getOptionLabel={option => option.label}
                renderInput={params => (
                    <TextField
                        {...params}
                        label={label}
                        variant="outlined"
                        InputProps={{
                            ...params.InputProps,
                            classes: {
                                input: classes.autocompleteInputProps
                            }
                        }}
                        InputLabelProps={{
                            ...params.InputLabelProps,
                            className: classes.autocompleteLabelProps
                        }}
                    />
                )}
                renderOption={option => {
                    return <p className={classes.autocompleteOptions}>{`${option.label}`}</p>;
                }}
                ChipProps={{ className: classes.autocompleteChipProps }}
            />
        </Box>
    );
}

export default withStyles(filters)(CoursesFilter);
